import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown, Icon} from 'semantic-ui-react';
import {Actions} from '../../actions';
import './newMenu.scss';

class AppMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'selectedOption': '',
    };
    this.closeMenu = this.closeMenu.bind(this);
  }

  closeMenu() {
    this.setState({'selectedOption': ''});
  }

  toggleMenu(option) {
    if (this.state.selectedOption === option) {
      this.closeMenu();
      return;
    }

    this.setState({'selectedOption': option});
  }

  back() {
    this.moveToPosition('scrollDown');
  }

  next() {
    this.moveToPosition('scrollUp');
  }

  moveToPosition(direction) {
    const newPosition = direction === 'scrollUp' ? +15 : -15;
    const element = document.getElementsByName('main-menu')[0];
    element.scrollLeft = element.scrollLeft + newPosition;
  }

  renderPreviousArrow() {
    const {showArrowsInMenu} = this.state;
    if (!showArrowsInMenu) {
      return null;
    }
    return (
      <div className='arrows previous-menu-item' onClick={this.back.bind(this)}>
        <Icon name='left chevron' size='small' />
      </div>
    );
  }

  renderNextArrow() {
    const {showArrowsInMenu} = this.state;
    if (!showArrowsInMenu) {
      return null;
    }
    return (
      <div className='arrows next-menu-item' onClick={this.next.bind(this)}>
        <Icon name='left chevron' size='small' />
      </div>
    );
  }

  renderMenu(options) {
    const {selectedOption} = this.state;
    return options.map((item, index) => {
      const isSelected = item.name === selectedOption;
      const styleClass = isSelected ? 'main-option selected' : 'main-option';
      const isLongMenu = options.length > 5 ? 'long-menu' : '';

      return (
        <Dropdown
          key={index}
          open={isSelected}
          onClose={this.closeMenu}
          icon={`${item.icon} principal`}
          text={item.name}
          className={`icon ${styleClass} ${isLongMenu}`}
          onClick={this.toggleMenu.bind(this, item.name)}
          button
        >
          <Dropdown.Menu>
            {this.renderInternalOptions(item.options, 2)}
          </Dropdown.Menu>
        </Dropdown>
      );
    });
  }

  renderInternalOptions(options, level) {
    if (level === 4) {
      return this.renderLastOptions(options);
    }

    return this.renderLevelOptions(options, level + 1);
  }

  renderLevelOptions(options, level) {
    return options.map((item, index) => {
      return (
        <Dropdown.Item key={index}>
          <Dropdown
            text={item.name}
            icon='angle right'
          >
            <Dropdown.Menu
              direction='right'
              className={level === 4 ? 'last-level' : ''}
            >
              {this.renderInternalOptions(item.options, level)}
            </Dropdown.Menu>
          </Dropdown>
        </Dropdown.Item>
      );
    });
  }

  renderLastOptions(options) {
    return options.map((item, index) => {
      return (
        <Dropdown.Item
          key={index}
          className='last-option'
          onClick={this.handleOptionClick.bind(this, item)}
        >
          {this.renderFavoriteIcon(item.resource)}
          {item.name}
        </Dropdown.Item>
      );
    });
  }

  handleOptionClick(option) {
    this.props.processOptionPopularity(option.resource);
    this.props.navigateTo(option.path);
  }

  renderFavoriteIcon(resource) {
    const isFavorite = this.checkFavoriteOption(resource);
    const iconClass = isFavorite ? 'menu-active' : 'menu-inactive';
    const onClick = isFavorite ? this.removeFavorite : this.addFavorite;
    return (
      <Icon
        link
        name='star'
        className={iconClass}
        size='large'
        onClick={onClick.bind(this, resource)}
      />
    );
  }

  checkFavoriteOption(resource) {
    return this.props.favoriteOptions.indexOf(resource) > -1;
  }

  addFavorite(resource, event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.addFavoriteOption(resource);
    this.closeMenu();
  }

  removeFavorite(resource, event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.removeFavoriteOption(resource);
    this.closeMenu();
  }

  render() {
    return (
      <div className='main-menu-container'>
        {this.renderPreviousArrow()}
        {this.renderMenu(this.props.menu)}
        {this.renderNextArrow()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (Object.keys(state).length > 0) {
    return {
      'menu': state.menu.menuItems,
      'favoriteOptions': state.menu.menuFavorite,
      'permissions': state.session.permissions,
      'loadingFavorite': state.menu.loadingFavorite,
    };
  }
};

const {
  addFavoriteOption,
  removeFavoriteOption,
  processOptionPopularity,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  addFavoriteOption,
  removeFavoriteOption,
  processOptionPopularity,
  navigateTo,
})(AppMenu);
